module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_m_albino.f4b1d199.png";